  /**
   * Shopify Cart Validation - Ensure minimum 1 full-priced item before checkout
   * Add this to your theme's JavaScript file
   */
  (function() {
    'use strict';

    // Configuration
    const DISCOUNT_AMOUNT_TO_REMOVE = 3000; // $30 in cents

    /**
     * Check if cart has at least one full-priced item (no compare_at_price)
     */
    async function validateCartAndProceed(event, checkoutUrl) {
      event.preventDefault();
      event.stopPropagation();

      try {
        // Fetch current cart state
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Check if there's at least one full-priced item
        const hasFullPricedItem = cart.items.some(item => {
          // Item is full-priced if:
          // 1. No compare_at_price (not on sale), AND
          // 2. No line-level discounts applied
          const hasNoComparePrice = !item.compare_at_price || item.compare_at_price === 0 || item.compare_at_price === item.price;
          const hasNoDiscounts = !item.line_level_discount_allocations || item.line_level_discount_allocations.length === 0;
          const isFullPrice = hasNoComparePrice && hasNoDiscounts;

          console.log('Checking item:', item.title, {
            hasNoComparePrice,
            hasNoDiscounts,
            isFullPrice,
            compare_at_price: item.compare_at_price,
            discounts: item.line_level_discount_allocations
          });

          return isFullPrice;
        });

        console.log('Has full-priced item in cart?', hasFullPricedItem);

        if (!hasFullPricedItem) {
          // No full-priced items - remove items with $30 discount
          const itemsToRemove = cart.items.filter(item => {
            // Check if item has a $30 discount applied
            if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
              return item.line_level_discount_allocations.some(discount =>
                discount.amount === DISCOUNT_AMOUNT_TO_REMOVE
              );
            }
            return false;
          });

          if (itemsToRemove.length > 0) {
            console.log('Removing discounted items:', itemsToRemove);

            // Remove each discounted item from cart
            const updates = {};
            itemsToRemove.forEach(item => {
              updates[item.key] = 0; // Set quantity to 0 to remove
            });

            // Update cart
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ updates })
            });

            // Refresh the page to show updated cart
            alert('Discounted items have been removed from your cart as they require at least one full-priced item.');
            window.location.reload();
            return;
          }
        }

        // Cart is valid, proceed to checkout
        window.location.href = checkoutUrl;

      } catch (error) {
        console.error('Error validating cart:', error);
        // On error, allow checkout to proceed
        window.location.href = checkoutUrl;
      }
    }

    /**
     * Initialize checkout button interception using event delegation
     */
    function initCheckoutValidation() {
      // Use event delegation on document to catch dynamically loaded buttons
      document.addEventListener('click', function(e) {
        // Check if clicked element or parent is a checkout button
        const target = e.target.closest('button[name="checkout"], input[name="checkout"], .btn-checkout, [href="/checkout"], [href*="/checkouts/"], .cart__checkout-button, .checkout-button, button.checkout');

        if (target) {
          console.log('Checkout button clicked, validating cart...', target);
          const checkoutUrl = target.href || '/checkout';
          validateCartAndProceed(e, checkoutUrl);
        }
      }, true); // Use capture phase to intercept before other handlers
    }

    // Initialize as soon as possible
    initCheckoutValidation();

    // Also watch for cart sidebar being opened/updated
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.matches && node.matches('.mini_cart_footer, #cs_cart_canvas') || (node.querySelector && node.querySelector('.mini_cart_footer, .btn-checkout')))) {
              console.log('Cart footer loaded/updated');
            }
          });
        }
      });
    });

    // Start observing when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }

  })();